import { Link } from "react-router-dom";
import { ShieldCheck, Lock } from "lucide-react";

const COMPANY = "Fátima & Tavares, Lda. · Rua da Portela, 42, 1800-306 Lisboa · NIPC 502 453 079";
const BADGES = [[ShieldCheck, "GDPR Compliant", "gdpr"], [Lock, "EU eSignatures", "esign"]];

export function TrustBadges() {
  return (
    <div className="flex flex-wrap gap-2 [.text-center_&]:justify-center" data-testid="trust-badges">
      {BADGES.map(([Icon, label, k]) => (
        <span key={k} className="inline-flex items-center gap-1.5 h-8 px-3.5 rounded-full border border-slate-200 bg-slate-50 text-[13px] font-semibold text-slate-700" data-testid={`trust-badge-${k}`}>
          <Icon size={15} strokeWidth={2.2} className="text-[#14B88F]" />{label}
        </span>
      ))}
    </div>
  );
}

export const LEGAL_LINKS = {
  pt: [["/termos", "Termos"], ["/privacidade", "Privacidade"], ["/seguranca", "Segurança"]],
  en: [["/en/terms", "Terms"], ["/en/privacy", "Privacy"], ["/en/security", "Security"]],
};

// Rodapé legal de todas as páginas públicas (página inicial, login e páginas legais).
export function LegalFooter({ en = false, className = "" }) {
  return (
    <div className={`text-xs text-slate-500 space-y-2 ${className}`} data-testid="legal-footer">
      <TrustBadges />
      <p data-testid="legal-footer-company">{en ? "ImoDesk is a brand of" : "ImoDesk é uma marca de"} {COMPANY}</p>
      <nav className="flex flex-wrap gap-x-4 gap-y-1">
        {LEGAL_LINKS[en ? "en" : "pt"].map(([to, l]) => (
          <Link key={to} to={to} className="hover:underline hover:text-slate-800" data-testid={`legal-footer-${to.split("/").pop()}`}>{l}</Link>
        ))}
      </nav>
    </div>
  );
}
